import { index, store, update, destroy } from '../../services/sizes/sizes'
import Vue from 'vue'
export const sizes = {

  namespaced: 'sizes',

  state: {
    data: {},
    pagination: {},
    details: {},
    loading: true,
    error: null
  },

  actions: {

    index ({ state, commit }, { page, name }) {
      commit('setLoading', true)
      index(page, name)
        .then(response => {
          commit('setData', response.data.sizes)
          commit('setPagination', response.data.sizes)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    store ({ state, commit, dispatch }, data) {
      commit('setLoading', true)
      store(data)
        .then(response => {
          commit('setDetails', response.data.size)
          commit('setLoading', false)
          Vue.toasted.success('Tamanho cadastrada com sucesso!')
          dispatch('index', { page: 1 })
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao cadastrar a Tamanho!')
        })
    },

    update ({ state, commit, dispatch }, { id, data }) {
      commit('setLoading', true)
      update(id, data)
        .then(response => {
          commit('setDetails', response.data.size)
          commit('setLoading', false)
          Vue.toasted.success('Tamanho editada com sucesso!')
          dispatch('index', { page: 1 })
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao editar a Tamanho!')
        })
    },

    destroy ({ state, commit, dispatch }, data) {
      commit('setLoading', true)
      destroy(data)
        .then(response => {
          commit('setDetails', response.data.size)
          commit('setLoading', false)
          Vue.toasted.success('Tamanho excluída com sucesso!')
          dispatch('index', { page: 1 })
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao excluir a Tamanho!')
        })
    }

  },

  mutations: {

    setData (state, sizes) {
      state.data = sizes
    },

    setDetails (state, size) {
      state.details = size
    },

    setLoading (state, status) {
      state.loading = status
    },

    setPagination (state, paginate) {
      state.pagination = paginate
    },

    setError (state, error) {
      if (error.status === 401) {
        localStorage.clear()
        window.location.href = './login'
      }
    }

  },

  getters: {}

}
